import { Button, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutLoadMatchToolPanel extends Layout {
    buttonDecline: Button;
    buttonPreassignLoad: Button;
    panel1: Panel;
}
